<template>
  <div class="space-y-3" :class="{ 'opacity-50 pointer-events-none': !props.isActive || props.isSubmitting }">
    <div class="bg-gray-800 border border-gray-600 rounded-lg overflow-hidden">
      <div
        v-for="field in fields"
        :key="field.key"
        class="flex items-center justify-between p-3 border-b border-gray-700 last:border-b-0 transition-colors"
        :class="props.isActive && !props.isSubmitting ? 'hover:bg-gray-750 group' : ''"
      >
        <div class="flex-1 min-w-0">
          <div class="text-xs text-gray-400 mb-1">{{ field.label }}</div>
          <div class="text-sm text-white break-words">{{ field.value }}</div>
        </div>
        <Button 
          @click="$emit('edit', field.key)"
          size="sm"
          variant="ghost"
          :class="props.isActive && !props.isSubmitting ? 'ml-2 flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity' : 'ml-2 flex-shrink-0 opacity-30 cursor-not-allowed'"
          :disabled="!props.isActive || props.isSubmitting"
        >
          <Pencil class="w-4 h-4" />
        </Button>
      </div>
    </div>
    
    <div class="flex gap-2">
      <Button 
        @click="$emit('confirm')" 
        class="flex-1"
        :disabled="isSubmitting || !props.isActive"
      >
        <Check class="w-4 h-4 mr-2" />
        {{ isSubmitting ? $t('clusterBuilding.submitting') : $t('clusterBuilding.confirmSubmit') }}
      </Button>
      <Button 
        @click="$emit('cancel')" 
        variant="outline"
        :disabled="isSubmitting || !props.isActive"
      >
        <X class="w-4 h-4 mr-2" />
        {{ $t('clusterBuilding.cancelButton') }}
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Pencil, Check, X } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import type { ClusterFormData } from '~/types/cluster'

interface Props {
  formData: ClusterFormData
  isSubmitting?: boolean
  isActive?: boolean
}

const props = defineProps<Props>()
const emit = defineEmits<{
  edit: [field: string]
  confirm: []
  cancel: []
}>()

const { t } = useI18n()

const fields = computed(() => [
  { key: '1', label: t('clusterBuilding.fields.name'), value: props.formData.name },
  { key: '2', label: t('clusterBuilding.fields.email'), value: props.formData.email },
  { key: '3', label: t('clusterBuilding.fields.requirements'), value: props.formData.requirements },
  { key: '4', label: t('clusterBuilding.fields.gpuCount'), value: props.formData.gpuCount?.toString() || '' },
  { key: '5', label: t('clusterBuilding.fields.duration'), value: props.formData.duration },
  { key: '6', label: t('clusterBuilding.fields.projectDetails'), value: props.formData.projectDetails },
])
</script>
